import styles from "../../styles/pages/home-dashboard.module.scss";
import Box from "@mui/material/Box";
import { Button, Grid, List, ListItem } from "@mui/material";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import assest from "../../json/assest/index";
import { expensesBreakdownList } from "../../api/functions/user.api";
import { useQuery } from "react-query";
import ExpensesModal from "../ModalTables/Expenses/ExpensesModal";

const ExpensesBreakdown = ({ ref1 }) => {
  const [openExpenseModal, setOpenExpenseModal] = useState(false);
  const [expenseDetails, setExpenseDetails] = useState({
    year: "",
    month: "",
    monthName: "",
  });
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [isYearListOpen, setIsYearListOpen] = useState(false);
  const expenseModalHandler = () => setOpenExpenseModal(!openExpenseModal);
  const currentMonth = new Date().getMonth() + 1;
  const showYearListHandler = () => setIsYearListOpen(!isYearListOpen);
  const getSelectedYear = (year) => {
    setSelectedYear(year);
    showYearListHandler();
  };
  const selectedExpense = (data) => {
    const { month, month_no } = data;
    setExpenseDetails({
      monthName: month,
      month: month_no,
      year: selectedYear,
    });
  };
  // const yearList = useMemo(() => {
  //   const currentYear = new Date().getFullYear();
  //   const startingYear = 2021;
  //   const yearArray = [];

  //   /*  for (let year = startingYear; year <= currentYear; year++) {
  //     yearArray.push(year);
  //   } */

  //   for (let year = currentYear; year >= startingYear; year--) {
  //     yearArray.push(year);
  //   }

  //   return yearArray;
  // }, [new Date().getFullYear()]);

  const yearList = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startingYear = 2021;
    const yearArray = [];

    for (let year = currentYear; year >= startingYear; year--) {
      yearArray.push(year);
    }

    return yearArray.filter((year) => year !== selectedYear); // Exclude the selected year
  }, [new Date().getFullYear(), selectedYear]);

  const { data: expensesList, isLoading } = useQuery(
    ["EXPENSE_BREAKDOWN", selectedYear],
    (body) => expensesBreakdownList(body, { year: selectedYear }),
    {
      select: (data) =>
        data && data.length > 0
          ? data.map((_d, idx) => {
              return { ..._d, month_no: idx + 1 };
            })
          : [],
    }
  );

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (isYearListOpen && !ref1.current.contains(e.target)) {
        setIsYearListOpen(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isYearListOpen, ref1]);

  console.warn("dashboard ExpensesBreakdown", expenseDetails);
  return (
    <>
      <Box
        className={`commonSmallBox commonSmallBox2 commonBoxExpenses ${styles.expensesBox} ${styles.expensesBox_new}`}
      >
        <Box className={`${styles.commonSmallBox}`}>
          <Box className={styles.infoTable}>
            <Box
              className={`${styles.infoTable_head} ${styles.infoTable_headFirst}`}
            >
              <Link href="">
                <Box className={styles.tble_hdng}>Expenses Breakdown</Box>
                <Box className={styles.tble_hdng}>
                  <Button
                    ref={ref1}
                    onClick={showYearListHandler}
                    className={`${isYearListOpen ? styles.active_drop : null}`}
                  >
                    {selectedYear == new Date().getFullYear() ? (
                      <>
                        <span className={styles.yr_spn}>This year</span>
                      </>
                    ) : (
                      selectedYear
                    )}
                    {isYearListOpen ? (
                      <img src={assest.upArrow} width={7} height={10} alt="" />
                    ) : (
                      <img
                        src={assest.downArrow}
                        width={7}
                        height={10}
                        alt=""
                      />
                    )}
                  </Button>

                  {isYearListOpen ? (
                    <Box className={styles.year_drop}>
                      <ul>
                        {yearList.map((_y) => (
                          <li onClick={() => getSelectedYear(_y)}>
                            {_y == new Date().getFullYear() ? "This year" : _y}
                          </li>
                        ))}
                      </ul>
                    </Box>
                  ) : null}
                </Box>
              </Link>
            </Box>

            <Box className={styles.infoTble_body}>
              <Box className={styles.infoTble_row}>
                <List className={styles.infotable_ul_row}>
                  {expensesList &&
                    expensesList?.length > 0 &&
                    expensesList.map((_item) => (
                      <ListItem
                        onClick={() => {
                          if (
                            (selectedYear === new Date().getFullYear() &&
                              _item?.month_no <= currentMonth) ||
                            selectedYear < new Date().getFullYear()
                          ) {
                            selectedExpense(_item);
                            expenseModalHandler();
                          }
                        }}
                        key={_item?.month_no}
                        className={`${
                          currentMonth == _item?.month_no &&
                          new Date().getFullYear() == selectedYear
                            ? styles.active
                            : currentMonth < _item?.month_no &&
                              new Date().getFullYear() == selectedYear
                            ? styles.deactive
                            : "hover_box"
                        }`}
                      >
                        <Box className={styles.innerexpense_modal}>
                          <Button>
                            <p>{_item?.month}</p>
                            <p>{`${
                              currentMonth < _item?.month_no &&
                              new Date().getFullYear() == selectedYear
                                ? "-"
                                : `$${_item?.count}`
                            }`}</p>
                          </Button>
                        </Box>
                      </ListItem>
                    ))}
                </List>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <ExpensesModal
        open={openExpenseModal}
        onClose={expenseModalHandler}
        selectedYearMonth={expenseDetails}
      />
    </>
  );
};

export default memo(ExpensesBreakdown);
